import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectPodcastSubmit, setPodcastFollows, selectSimilarPodcast, addPodcastFollows, } from '../podcastSubmitSlice'

import { useAnimate, stagger, motion, AnimatePresence } from "framer-motion";

import { useMediaQuery } from 'react-responsive';

//import dayjs from 'dayjs';
//import DOMPurify from 'dompurify';
import {
  //Dimmer,
  //Loader,
  Segment,
  Button,
  //List,
  Image,
  Header,
  Grid,
  //Accordion,
  Icon,
  Label,
  //Input,
  Item,
  Card,
  Popup,
  Placeholder,
  Progress,
} from 'semantic-ui-react';

// icons
import svg_icon_play from '../../../layouts/images/icons/icon-play.svg';

export default function PodcastRssPreview() {

  const isNotMobile = useMediaQuery({ minWidth: 768 });

  const [scope, animate] = useAnimate(); 

  /* const [isOpen, setIsOpen] = useState(false);
  const scope = useMenuAnimation(isOpen); */

  const dispatch = useDispatch();
  const { fileUpload, podcastSearch, podcastFollows } = useSelector(selectPodcastSubmit);

  const [episodesAccordionState, setEpisodesAccordionState] = useState({
    activeIndex: null,
  })
  const handleAccordianClick = (index) => {
    const newIndex = episodesAccordionState.activeIndex === index ? -1 : index
    setEpisodesAccordionState({ activeIndex: newIndex });
  }

  const handleReplaceClick = (e, index, podcast) => {
    //console.debug('handleReplaceClick', {e, index, podcast});
    e.preventDefault();
    const bestMatch = JSON.parse(JSON.stringify(podcastSearch.found[index].searchResults.bestMatch));
    bestMatch.id = podcast.id;
    bestMatch.podcast = podcast;
    dispatch(selectSimilarPodcast({index, bestMatch, podcastId: podcast.id}));
    handleAccordianClick(index)
  } 

  const handleAddRemoveClick = (index, podcastId) => {
    //console.debug('handleAddRemoveClick', {index, podcastId});
    dispatch(setPodcastFollows(podcastId));
  }

  useEffect(() => {
    if (fileUpload && fileUpload.json) {
      const staggerMenuItems = stagger(0.5, { startDelay: 0 }); 
      const sequence = [
        [".item", { opacity: 0, y: 400,  }],
        [".item", { opacity: 1,  y: 0,  }, { duration: 0.2, delay: staggerMenuItems, type: 'spring', bounce: 0.2, damping: 15 }] 
      ]
      animate(sequence); 
    }
  }, [fileUpload, animate]);

  return (
    <>
      <Segment basic className={'podcast-rss-preview'}> 
        {((fileUpload.json && fileUpload.json?.body?.outline && fileUpload.json.body.outline.length !== 0) && podcastSearch.loading && (podcastSearch.progress !== fileUpload.json.body.outline.length))?
          <Progress attached='top' total={fileUpload.json.body.outline.length} value={podcastSearch.progress} />
        :
          null
        }
        {((fileUpload.json && fileUpload.json?.body?.outline && fileUpload.json.body.outline.length !== 0) && podcastFollows.loading && (podcastFollows.progress !== fileUpload.json.body.outline.length))?
          <Progress attached='top' total={fileUpload.json.body.outline.length} value={podcastFollows.progress} />
        :
          null
        }
        <Grid columns={'equal'}>
          {!podcastSearch.loading && podcastSearch.error ?
            <Grid.Row style={{margin: '0', padding: '0',}}>
              <Grid.Column width={16}>
                <p>A Podcast Search error occurred</p>
              </Grid.Column>
            </Grid.Row>
          :
            null
          }
          <Grid.Row className={'search-results'+ (podcastFollows.loading || podcastFollows.error ? ' disabled' : '')}>
            <Grid.Column width={16}>
              <Segment basic loading={podcastFollows.loading || podcastFollows.error ? true : false}>
                <div ref={scope}>
                  <Item.Group>
                    {fileUpload.json && fileUpload.json?.body?.outline && fileUpload.json.body.outline.length !== 0 ?
                      fileUpload.json.body.outline.map((podcast, index) => {
                        const bestMatchPodcastId = (!podcastSearch.loading && podcastSearch.found && podcastSearch.found[index] && podcastSearch.found[index].searchResults && podcastSearch.found[index].searchResults.bestMatch) ? podcastSearch.found[index].searchResults.bestMatch.id : null;
                        const isFollowedSelected = bestMatchPodcastId && (podcastFollows.selectedFollows && podcastFollows.selectedFollows[bestMatchPodcastId]);

                        //const isFollowed = (!podcastSearch.loading && podcastSearch.found && podcastSearch.found[index] && podcastSearch.found[index].searchResults) && podcastFollows.selectedFollows && podcastFollows.selectedFollows.length !== 0 && podcastFollows.selectedFollows[index] === podcastSearch.found[index].searchResults.bestMatch.podcast.id;
                        return (
                          <React.Fragment key={index}>
                            <Item className={(episodesAccordionState.activeIndex === index ? 'open' : 'closed') + (isFollowedSelected ? ' followed' : ' unfollowed')}>
                              {!podcastSearch.loading && podcastSearch.found ?
                                (podcastSearch.found[index] && !podcastSearch.found[index].error && podcastSearch.found[index].searchResults && podcastSearch.found[index].searchResults.bestMatch.podcast ?
                                  <>
                                    <Popup inverted hoverable position='bottom center'
                                      trigger={
                                        <Label 
                                        //as='button' 
                                        attached='top right' 
                                        className={(podcastSearch.found[index].following || isFollowedSelected ? 'brand-red' : null)}
                                        //onClick={()=>{handleAddRemoveClick(index, podcastSearch.found[index].searchResults.bestMatch.podcast.id)}}
                                        >
                                          <Icon name={podcastSearch.found[index].following ? 'heart' : isFollowedSelected ? 'check' : 'cancel'} />
                                          {podcastSearch.found[index].following ? 'Already Followed' : (isFollowedSelected) ? 'Selected' : 'Unfollowed'}
                                        </Label>
                                      }
                                    >
                                        <p style={{fontSize: '10px'}}>
                                          {podcastSearch.found[index].following ? 'Already Followed on iHeartRadio' : isFollowedSelected ? 'Selected to add to your Follow library' : 'Not Selected To Follow'}
                                        </p>
                                    </Popup>
                                    <div className={'image'}>
                                      <a className='overlay-container' href={'https://www.iheart.com/podcast/'+podcastSearch.found[index].searchResults.bestMatch.id+'/'} target={'_blank'} rel={'noreferrer'}>
                                        <Item.Image size='tiny' src={podcastSearch.found[index].searchResults && podcastSearch.found[index].searchResults.bestMatch.podcast.image ? podcastSearch.found[index].searchResults.bestMatch.podcast.image : null} />
                                        <div className={'overlay'}>
                                          <Image wrapped size={'mini'} src={svg_icon_play} alt={'play icon'} />
                                        </div>
                                      </a>
                                    </div>
                                    <Item.Content>
                                      <Item.Header>
                                        {/* <Icon name='heart' className={podcastSearch.found[index].following ? 'active' : null} /> */}
                                        {podcastSearch.found[index].searchResults.bestMatch.podcast.title}
                                      </Item.Header>
                                      <Item.Meta>
                                        <Label.Group size='mini'>
                                          <Label as={'a'} href={podcast.xmlUrl} target={'_blank'} rel={'noreferrer'}>
                                            <Icon name='rss' />
                                            Imported Podcast
                                            <Label.Detail>{podcast.title}</Label.Detail>
                                          </Label>
                                        </Label.Group>
                                      </Item.Meta>
                                      <Item.Description>
                                        {podcastSearch.found[index].searchResults.bestMatch.podcast.subtitle}
                                      </Item.Description>
                                      <Item.Extra>
                                        {!podcastSearch.found[index].following ?
                                          <Button size={isFollowedSelected ? 'tiny' : 'small'}
                                            primary={isFollowedSelected ? null : true} 
                                            secondary={isFollowedSelected ? true : null}
                                            onClick={()=>{handleAddRemoveClick(index, podcastSearch.found[index].searchResults.bestMatch.id)}}
                                            disabled={(podcastFollows.loading || podcastFollows.error)}
                                          >
                                            <Icon name={isFollowedSelected ? 'delete' : 'add'} />
                                            {isFollowedSelected ? 'Remove Podcast Follow' : 'Add Podcast Follow'}
                                          </Button>
                                        :
                                          null
                                        }
                                        <Button secondary size={'tiny'} floated='right'
                                          onClick={()=>{handleAccordianClick(index)}}
                                          disabled={(podcastFollows.loading || podcastFollows.error)}
                                        >
                                          Not the right Podcast?
                                        </Button>
                                      </Item.Extra>
                                    </Item.Content>
                                  </>
                                :
                                  <>
                                    {/* <Label attached='top right'>
                                      Invalid
                                    </Label> */}
                                    <Item.Content>
                                      <Item.Header>
                                        <p>{'Podcast Title'}</p>
                                        {podcast.title && podcast.title !== '' ? podcast.title : 'Title Not Provided'}
                                      </Item.Header>
                                      <Item.Meta>
                                        <Label size={'mini'} as={'a'} href={podcast.xmlUrl && podcast.xmlUrl !== '' ? podcast.xmlUrl : null} target={'_blank'} rel={'noreferrer'}>
                                          RSS URL
                                          <Label.Detail>{podcast.xmlUrl && podcast.xmlUrl !== '' ? podcast.xmlUrl : 'RSS URL Not Provided'}</Label.Detail>
                                        </Label>
                                      </Item.Meta>
                                      <Item.Description>
                                        If you are unable to find a specific show, you can <a href={'https://help.iheart.com'} target={'_blank'} rel="noreferrer" aria-label={'iHeartRadio Help Link'}>notify our support team</a> and we'll work to get it added.
                                      </Item.Description>
                                    </Item.Content>
                                  </>
                                )
                              :
                                <>
                                  <div className={'image'}>
                                    <Placeholder>
                                      <Placeholder.Image square />
                                    </Placeholder>
                                  </div>
                                  <Item.Content>
                                    <Item.Header>
                                      <Placeholder>
                                        <Placeholder.Header>
                                          <Placeholder.Line length='full' />
                                        </Placeholder.Header>
                                      </Placeholder>
                                    </Item.Header>
                                    <Item.Meta>
                                      <Placeholder>
                                        <Placeholder.Line length='medium' />
                                      </Placeholder>
                                    </Item.Meta>
                                    <Item.Description>
                                      <Placeholder>
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                      </Placeholder>
                                    </Item.Description>
                                    <Item.Extra>
                                      <Placeholder>
                                        <Placeholder.Line length='short' />
                                      </Placeholder>
                                    </Item.Extra>
                                  </Item.Content>
                                </>
                              }
                            </Item>
                            <AnimatePresence initial={false}>
                              {!podcastSearch.loading && podcastSearch.found && podcastSearch.found[index] && podcastSearch.found[index].searchResults && episodesAccordionState.activeIndex === index ?
                                <motion.div className={'expander'+ (episodesAccordionState.activeIndex === index ? ' open' : ' closed')}
                                  initial={{ opacity: 0, y: -100, height: 0, }}
                                  animate={{ opacity: 1, y: 0, height: 'auto' }}
                                  transition={{ delay: 0 }}
                                  exit={{ opacity: 0, y: -100, height: 0, duration: 0 }}
                                >
                                  <Segment basic>
                                    <Header as={'h4'} content={'Similar Podcasts'} subheader={<div className='sub header'>Select a similar Podcast to Follow if we didn't find the best match.<span>If you are unable to find a specific show, you can <a href={'https://help.iheart.com'} target={'_blank'} rel="noreferrer" aria-label={'iHeartRadio Help Link'}>notify our support team</a> and we'll work to get it added.</span></div>} />
                                    {podcastSearch.found[index].searchResults.podcasts.length !== 0 ?
                                      <Card.Group itemsPerRow={isNotMobile ? 4 : 2}>
                                        {podcastSearch.found[index].searchResults.podcasts.map((podcast, indexInner) => (
                                          <Card key={indexInner} link href={'https://www.iheart.com/podcast/'+podcast.id+'/'} target={'_blank'} rel={'noreferrer'}
                                          aria-label={'Listen on iHeartRadio Link'}
                                            //style={{background: 'url("'+podcast.image+'") no-repeat'}}
                                          >
                                            <Image src={podcast.image} />
                                            <Card.Content>
                                              <Card.Header>{podcast.title}</Card.Header>
                                              <Button primary size={'tiny'}
                                                disabled={podcast.id === podcastSearch.found[index].searchResults.bestMatch.id}
                                                onClick={(e)=>{handleReplaceClick(e, index, podcast)}}
                                              >
                                                Replace
                                              </Button>
                                            </Card.Content>
                                          </Card>
                                        ))}
                                      </Card.Group>
                                    :
                                      <p>No other matches</p>
                                    }
                                  </Segment>
                                </motion.div>
                              :
                                null
                              }
                            </AnimatePresence>
                          </React.Fragment>
                        )
                      })
                    :
                      null
                    }
                  </Item.Group>
                  {isNotMobile ?
                    null
                  :
                    <div className={'button-wrapper'}>
                      <Button primary fluid
                        loading={podcastFollows.loading}
                        disabled={podcastFollows.loading || podcastFollows.error !== null || podcastFollows.totalFollows === 0}
                        onClick={()=>{dispatch(addPodcastFollows())}}
                        style={{marginTop: '50px', }}
                      >
                        Follow Selected Podcasts
                      </Button>
                    </div>
                  }
                </div>
              </Segment>
              
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  )
}